import {IngredientMeasurementUnit} from 'graphql-client/__generated/graphqlGlobalTypes';
import {MixtureMetadataStructuredTableMetadata} from 'notebook/integrations/registry/MixtureMetadataStructuredTableAdapter';
import {MixtureGroup} from 'notebook/integrations/registry/MixtureNoteLinkedGroupAdapter';
import {getMixtureGroupAdapter} from 'notebook/notes/groups/NoteLinkedGroupAdapters';
import {NoteLinkedGroupKind} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {OutputTableMap} from 'notebook/tables/excess/EvaluationConstants';
import {NoteLinkedObject, NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';

// Keep in sync with `benchling/lib/qs.py`
export const QS_AMOUNT = 'QS';
export const _VALID_QS_INPUTS = new Set([QS_AMOUNT, 'qs', 'Q.S.', 'q.s.']);

export function isAmountQs(amountStr: string): boolean {
  return _VALID_QS_INPUTS.has(amountStr.trim());
}

// This type handles one special non-numeric value "QS". In that case, stringValue='QS' and numericValue=NaN.
export interface NumericString {
  stringValue: string;
  numericValue: number;
}

export interface MixtureGroupMetadata {}

export interface CreateMixtureGroupExtras {
  mixtureMetadataTableMetadata: MixtureMetadataStructuredTableMetadata;
  getNextUniqueName: (prefix: string, options?: {allowNoSuffix?: boolean}) => string;
}

export interface IngredientDataFromParent {
  componentBioentitySummary: {id: string; displayLabel: string};
  units: IngredientMeasurementUnit;
  catalogIdentifier: string | null;
  parentIngredientId: string;
  // If parentIngredientAmount is non-null, then this will be an inherited ingredient
  parentIngredientAmount: NumericString | null;
  notes: string | null;
}

export function isMixtureGroup(noteLinkedObject: NoteLinkedObject): noteLinkedObject is MixtureGroup {
  return (
    noteLinkedObject.type === NoteLinkedObjectType.NOTE_LINKED_GROUP &&
    noteLinkedObject.kind === NoteLinkedGroupKind.MIXTURE_GROUP
  );
}

export function isMixtureGroupWithCreatedMixture(
  noteLinkedObject: NoteLinkedObject,
  evaluatedTableMap: OutputTableMap | null
): boolean {
  return (
    isMixtureGroup(noteLinkedObject) &&
    getMixtureGroupAdapter().getMixtureId(noteLinkedObject, evaluatedTableMap) != null
  );
}
